export default {
  // 'rgb(78, 58, 123)',
  primary: '#3f2f62',

  primaryLight: '#543e86',
  primaryVibrant: '#5742e4',
  link: '#0366d6',
  textDark: '#1C1D20',
  textFaint: '#7f858b',
  textDisabled: '#aab2bb',
  red: '#CF1322',

  accent: '#c13031',
  accentBg: '#f7e5e5',
  neutral100: '#1f2433',
  neutral80: '#434a60',
  neutral70: '#535353',
  neutral60: '#646e87',
  neutral40: '#9fa6b6',
  neutral20: '#d9dce4',
  neutral10: '#eff0f3',
  neutral5: '#F7F8FB',
  neutral0: '#ffffff',
  green: '#256029',
  greenBg: '#dcebdd',
  greenLight: '#2f9e44',
  greenLightBg: '#e7f5ea',
  blue: '#2f6db8',
  blueBg: '#ecf2f9',
  yellow: '#dd8503',
  yellowBg: '#fdf6eb',
  blueGrey: '#37474f',
  blueGreyBg: '#cfd8dc',
  turquoise: '#006064',
  turquoiseBg: '#D5F4F8',
};
